/**
 * Determine whether the argument is a window (IE9+)
 */
export default function isWindow(value) {
  var type = Object.prototype.toString.call(value);
  return type === '[object global]' || type === '[object Window]' || type === '[object DOMWindow]';
}
//# sourceMappingURL=isWindow.js.map